module.exports = __webpack_public_path__ + "img/ni.5838f40b.svg";